(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[254],{

/***/ 60833:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/online/exhibitor",
      function () {
        return __webpack_require__(82429);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83844);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);






var Pagination = function(param) {
    var page = param.page, total = param.total, _size = param.size, size = _size === void 0 ? 4 : _size, url = param.url, _pagerCount = param.pagerCount, pagerCount = _pagerCount === void 0 ? 5 : _pagerCount;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var getUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(page) {
        if (!url) {
            var query = [
                "page=".concat(page)
            ];
            for(var key in router.query){
                if (key === "page") continue;
                var value = router.query[key];
                query.push("".concat(key, "=").concat(value));
            }
            return "".concat(router.pathname, "?").concat(query.join("&"));
        } else {
            return "".concat(url).concat(page);
        }
    }, [
        url,
        router.query
    ]);
    var lastPage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return Math.max(1, Math.ceil(total / size));
    }, [
        total,
        size
    ]);
    var pageList = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var _list = [];
        var start = 1;
        var end = lastPage;
        if (lastPage > pagerCount + 2) {
            start = page > Math.ceil(pagerCount / 2) + 1 ? Math.max(1, page - Math.floor(pagerCount / 2)) : 1;
            end = page < lastPage - Math.ceil(pagerCount / 2) ? Math.min(lastPage, start + pagerCount - 1) : lastPage;
            if (end - start < pagerCount - 1) {
                start = end - pagerCount + 1;
            }
        }
        for(var i = start; i <= end; i++){
            _list.push(i);
        }
        return _list;
    }, [
        page,
        pagerCount,
        lastPage
    ]);
    var leftEllipsisVisible = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return pageList[0] > 2;
    }, [
        pageList
    ]);
    var leftEllipsisPage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return pageList[0] - 1;
    }, [
        pageList
    ]);
    var rightEllipsisVisible = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return pageList[pageList.length - 1] < lastPage - 1;
    }, [
        pageList,
        lastPage
    ]);
    var rightEllipsisPage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return pageList[pageList.length - 1] + 1;
    }, [
        pageList
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().pagination),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: page > 1 ? getUrl(page - 1) : "javascript:void(0)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(page <= 1 ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().disabled) : ""),
                    children: "<"
                })
            }),
            leftEllipsisVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: getUrl(1),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            children: "1"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: getUrl(leftEllipsisPage),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            children: "\xb7\xb7\xb7"
                        })
                    })
                ]
            }),
            pageList.map(function(item) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: item !== page ? getUrl(item) : "javascript:void(0)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(item === page ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active) : ""),
                        children: item
                    })
                }, item);
            }),
            rightEllipsisVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: getUrl(rightEllipsisPage),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            children: "\xb7\xb7\xb7"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: getUrl(lastPage),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            children: lastPage
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: page < lastPage ? getUrl(page + 1) : "javascript:void(0)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(page >= lastPage ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().disabled) : ""),
                    children: ">"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 82429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ ExhibitorList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(10797);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85957);
/* harmony import */ var _components_pagelay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28082);
/* harmony import */ var _components_seo_pagination__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90423);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2261);
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99304);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25194);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94375);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(59543);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81627);
/* harmony import */ var _utils_useHead__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(25838);


















var __N_SSP = true;
function ExhibitorList(param) {
    var menuDetail = param.menuDetail, countryList = param.countryList, fieldList = param.fieldList, data = param.data;
    var ref, ref1, ref2, ref3, ref4;
    console.log("数据", menuDetail, countryList, fieldList, data);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_11__.useRouter)();
    var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_13__/* .useTranslations */ .T_)();
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        company: "",
        country_id: "",
        category_ids: "",
        application_area_ids: "",
        letter: ""
    }), selected = ref5[0], setSelected = ref5[1];
    var gotoPage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(query) {
        query = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, router.query, query);
        for(var key in query){
            if (!query[key]) {
                delete query[key];
            }
        }
        router.push("".concat(router.pathname, "?").concat(new URLSearchParams(query).toString()));
    }, [
        router
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setSelected({
            company: router.query.company || "",
            country_id: router.query.country_id || "",
            category_ids: router.query.category_ids || "",
            application_area_ids: router.query.application_area_ids || "",
            letter: router.query.letter || ""
        });
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pagelay__WEBPACK_IMPORTED_MODULE_3__/* .PageLayout */ .X, {
        temp: "page_crumb",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().container),
            children: [
                (0,_utils_useHead__WEBPACK_IMPORTED_MODULE_12__/* .getHead */ .c)(menuDetail),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_10___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().content), "m-1480"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().top),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().title),
                                    children: t("online.title")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .II, {
                                    value: selected.company,
                                    placeholder: t("common.placeholder.company"),
                                    suffix: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().search),
                                        onClick: function() {
                                            gotoPage((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, selected), {
                                                page: 1
                                            }));
                                        }
                                    }),
                                    onChange: function(value) {
                                        setSelected((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, selected), {
                                            company: value
                                        }));
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().bottom),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().left),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().title),
                                            children: t("online.filter")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_2__/* .Collapse */ .UO, {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().item),
                                            defaultActiveKey: (selected === null || selected === void 0 ? void 0 : selected.category_ids) ? "1" : "",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_2__/* .Collapse.Panel */ .UO.Panel, {
                                                header: t("online.filter1Place"),
                                                itemKey: "1",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_2__/* .CheckboxGroup */ .cO, {
                                                    value: (selected === null || selected === void 0 ? void 0 : selected.category_ids) ? (ref = selected === null || selected === void 0 ? void 0 : selected.category_ids.split(",")) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                                                        return Number(item);
                                                    }) : [],
                                                    onChange: function(checkedValue) {
                                                        setSelected((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, selected), {
                                                            category_ids: checkedValue.join(",")
                                                        }));
                                                    },
                                                    children: menuDetail === null || menuDetail === void 0 ? void 0 : (ref1 = menuDetail.list) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, index) {
                                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_2__/* .Checkbox */ .XZ, {
                                                            value: item === null || item === void 0 ? void 0 : item.id,
                                                            children: item === null || item === void 0 ? void 0 : item["name_".concat(router.locale)]
                                                        }, index);
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_2__/* .Select */ .Ph, {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_10___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().item), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().select)),
                                            value: Number(selected === null || selected === void 0 ? void 0 : selected.country_id) || "",
                                            showClear: true,
                                            placeholder: t("online.filter2Place"),
                                            optionList: countryList === null || countryList === void 0 ? void 0 : countryList.map(function(item) {
                                                return {
                                                    label: item.name,
                                                    key: item.id,
                                                    value: item.id
                                                };
                                            }),
                                            onChange: function(value) {
                                                setSelected((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, selected), {
                                                    country_id: value
                                                }));
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_2__/* .Collapse */ .UO, {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().item),
                                            defaultActiveKey: (selected === null || selected === void 0 ? void 0 : selected.application_area_ids) ? "1" : "",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_2__/* .Collapse.Panel */ .UO.Panel, {
                                                header: t("online.filter3Place"),
                                                itemKey: "1",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_2__/* .CheckboxGroup */ .cO, {
                                                    value: (selected === null || selected === void 0 ? void 0 : selected.application_area_ids) ? (ref2 = selected === null || selected === void 0 ? void 0 : selected.application_area_ids.split(",")) === null || ref2 === void 0 ? void 0 : ref2.map(function(item) {
                                                        return Number(item);
                                                    }) : [],
                                                    onChange: function(checkedValue) {
                                                        setSelected((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, selected), {
                                                            application_area_ids: checkedValue.join(",")
                                                        }));
                                                    },
                                                    children: fieldList === null || fieldList === void 0 ? void 0 : fieldList.map(function(item, index) {
                                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_2__/* .Checkbox */ .XZ, {
                                                            value: item === null || item === void 0 ? void 0 : item.id,
                                                            children: item === null || item === void 0 ? void 0 : item["name"]
                                                        }, index);
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_10___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().item), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().search)),
                                            onClick: function() {
                                                gotoPage((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, selected), {
                                                    page: 1
                                                }));
                                            },
                                            children: t("online.search")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                            href: "/visitor/purchase",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_10___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().item), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().link)),
                                                target: "_blank",
                                                children: t("online.purchase")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().right),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().letter),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().title),
                                                    children: t("online.alph")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().filter),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: classnames__WEBPACK_IMPORTED_MODULE_10___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().prev), "swiper-button-prev")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .tq, {
                                                            className: classnames__WEBPACK_IMPORTED_MODULE_10___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().swiper)),
                                                            modules: [
                                                                swiper_modules__WEBPACK_IMPORTED_MODULE_7__/* .Navigation */ .W_
                                                            ],
                                                            navigation: {
                                                                prevEl: ".swiper-button-prev",
                                                                nextEl: ".swiper-button-next"
                                                            },
                                                            slidesPerView: "auto",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: classnames__WEBPACK_IMPORTED_MODULE_10___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().item), (selected === null || selected === void 0 ? void 0 : selected.letter) == "" && (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().active)),
                                                                        style: {
                                                                            borderLeft: "none"
                                                                        },
                                                                        onClick: function() {
                                                                            gotoPage((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, selected), {
                                                                                letter: "",
                                                                                page: 1
                                                                            }));
                                                                        },
                                                                        children: t("online.all")
                                                                    })
                                                                }),
                                                                (ref3 = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(Array(26))) === null || ref3 === void 0 ? void 0 : ref3.map(function(item, index) {
                                                                    var _letter = String.fromCharCode(65 + index);
                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: classnames__WEBPACK_IMPORTED_MODULE_10___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().item), (selected === null || selected === void 0 ? void 0 : selected.letter) === _letter ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().active) : ""),
                                                                            onClick: function() {
                                                                                gotoPage((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, selected), {
                                                                                    letter: _letter,
                                                                                    page: 1
                                                                                }));
                                                                            },
                                                                            children: _letter
                                                                        })
                                                                    }, index);
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: classnames__WEBPACK_IMPORTED_MODULE_10___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().next), "swiper-button-next")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().list),
                                            children: data === null || data === void 0 ? void 0 : (ref4 = data.list) === null || ref4 === void 0 ? void 0 : ref4.map(function(item, index) {
                                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                        href: "/online/exhibitor/info?id=".concat(item === null || item === void 0 ? void 0 : item.id),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().item),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().cover),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: item.logo || "http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg",
                                                                        alt: item === null || item === void 0 ? void 0 : item.company
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().info),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().name),
                                                                            children: item === null || item === void 0 ? void 0 : item.company
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().other),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                            children: t("online.country")
                                                                                        }),
                                                                                        item === null || item === void 0 ? void 0 : item.country
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                            children: t("online.booth")
                                                                                        }),
                                                                                        item === null || item === void 0 ? void 0 : item.booth_num
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                            children: t("online.appliIndustry")
                                                                                        }),
                                                                                        item === null || item === void 0 ? void 0 : item["application_area_".concat(router.locale)]
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                !!item.is_new && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default()["new"]),
                                                                    src: "http://admin.ipbexpo.com/uploads/editor/20250522/1d768871001222bd21322e845a7f2855.png",
                                                                    alt: ""
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }, index);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().pagination),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_seo_pagination__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                page: Number(router.query.page || 1),
                                                total: data === null || data === void 0 ? void 0 : data.total,
                                                size: data === null || data === void 0 ? void 0 : data.per_page
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 25838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getHead; }
/* harmony export */ });
/* unused harmony export getServerSideProps */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45844);





var getServerSideProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(context) {
        var ref, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/getHomeMenuDetail", {
                            params: {
                                path: context === null || context === void 0 ? void 0 : (ref = context.resolvedUrl) === null || ref === void 0 ? void 0 : ref.split("?")[0]
                            },
                            headers: {
                                lang: (context === null || context === void 0 ? void 0 : context.locale) || "cn"
                            }
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        {
                            props: {
                                navDetail: data.data || null,
                                menuDetail: data.data || null
                            }
                        }
                    ];
            }
        });
    });
    return function getServerSideProps(context) {
        return _ref.apply(this, arguments);
    };
}();
var getHead = function(menuDetail) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            (menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_title,
                    " "
                ]
            }),
            (menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_kws) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_kws
            }),
            (menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_desc) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_desc
            })
        ]
    });
};



/***/ }),

/***/ 83844:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"m-1480":"seo-pagination_m-1480__HQLDo","pagination":"seo-pagination_pagination__VyFuW","active":"seo-pagination_active__QulN_","disabled":"seo-pagination_disabled__DdGW1"};

/***/ }),

/***/ 59543:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"m-1480":"styles_m-1480__a1sam","container":"styles_container__oIu_E","content":"styles_content__feYL5","top":"styles_top__9JJ2a","title":"styles_title__fv1mt","search":"styles_search__oQeiK","bottom":"styles_bottom__qkvGa","left":"styles_left__Lae1i","select":"styles_select__cdNM3","link":"styles_link__jH_qR","right":"styles_right__pnnoD","letter":"styles_letter__VV96w","filter":"styles_filter__87tHE","prev":"styles_prev__4SFLE","next":"styles_next__Yvq2A","swiper":"styles_swiper__qdWts","item":"styles_item__w7NMU","active":"styles_active__22WR7","list":"styles_list__2_MRW","cover":"styles_cover__qDwE4","info":"styles_info__SEWVU","name":"styles_name__spKFr","other":"styles_other__AQ9uY","new":"styles_new__tkJuI","pagination":"styles_pagination__fVBk_"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [222,304,912,774,888,179], function() { return __webpack_exec__(60833); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);